import React from 'react';
import { useEffect } from "react";

const StickyNavHook = (widgetElement) => {
  useEffect(() => {
    if ((typeof window !== 'undefined') && (typeof document !== 'undefined')) {
      const widgets = document.getElementsByClassName('c-advanced-sticky-nav');
      const cleanups = [];

      for (let i = 0; i < widgets?.length; i++) {
        const widget = widgets[i];
        if (!widget) continue;
        if (widget.dataset && widget.dataset.stickyNavInit === '1') continue;
        if (widget.dataset) widget.dataset.stickyNavInit = '1';

        const cleanup = advancedStickyNav(widget);
        if (typeof cleanup === 'function') cleanups.push(cleanup);
      }

      return () => cleanups.forEach((fn) => { try { fn(); } catch {} });
    }
  }, []);

  function advancedStickyNav(widgetElement) {
    if (!widgetElement) return () => {};
    const OBSERVER_TOP_OFFSET = 180;
    const options = { rootMargin: `-${OBSERVER_TOP_OFFSET}px 0px -60% 0px`, threshold: 0 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry || !entry.target) return;
        const id = entry.target.getAttribute("id");
        if (!id) return;
        const el = widgetElement.querySelector(`.c-advanced-sticky-nav li a[href="#${CSS.escape(id)}"]`);
        const li = el ? el.parentElement : null;
        if (!li) return;

        if (entry.isIntersecting) {
          const allLis = widgetElement.querySelectorAll(".c-advanced-sticky-nav li");
          if (!allLis) return;
          allLis.forEach((n) => n.classList.remove("active"));
          li.classList.add("active");
        }
      });
    }, options);

    const mobileAncherMenu = widgetElement.querySelector(".c-advanced-sticky-nav .c-advanced-sticky-nav-anchor-bar-text");
    const links = widgetElement.querySelectorAll(".c-advanced-sticky-nav li a");
    const linksArr = Array.prototype.slice.call(links);

    const sectionIds = linksArr.map((el) => el.getAttribute("href"));

    sectionIds.forEach((id) => {
      if (!id || id == "#" || id.includes("http")) return;
      const observeSection = document.querySelector(id);
      if (observeSection) observer.observe(observeSection);
    });
    let clickTimeoutId = null;
    const clickHandler = function (e) {
      if (!e) return;
      e.preventDefault();
      var navHeight = 60;
      var stickyNavHeight = 80;
      const targetElement = this.getAttribute("href");
      if (!targetElement || targetElement == "#") return;

      const customOffset = this.dataset && this.dataset.offset ? parseInt(this.dataset.offset, 10) : 0;
      const offset = navHeight + stickyNavHeight + (isNaN(customOffset) ? 0 : customOffset);

      const list = this.parentElement && this.parentElement.parentElement && this.parentElement.parentElement.parentElement
      list && list.classList.remove("is-expanded");
      widgetElement.querySelector(".c-advanced-sticky-nav .c-advanced-sticky-nav-anchor-bar-text").classList.remove("is-expanded");

      if (clickTimeoutId) {
        clearTimeout(clickTimeoutId);
        clickTimeoutId = null;
      }
      
      clickTimeoutId = setTimeout(function () {      
        scrollIntoViewWithOffset(targetElement, offset);
        window.history.pushState(null, null, targetElement);
        clickTimeoutId = null;
      }, 500); 
    };

    linksArr.forEach((el) => {
      if (!el) return;
      if (el.dataset.boundClick === '1') return;
      el.addEventListener("click", clickHandler, { passive: false });
      el.dataset.boundClick = '1';
    });

    const toggleHandler = function (e) {
      if (!e) return;
      if (e.target.closest('.mobile.c-button.c-cta-button.is-primary')) {
        return; 
      }

      e.preventDefault();
      e.stopPropagation();

      const trigger = e.currentTarget;
      if (!trigger) return;
      const list = trigger.nextElementSibling;

      const willExpand = !trigger.classList.contains("is-expanded");
      trigger.classList.toggle("is-expanded", willExpand);
      if (list) list.classList.toggle("is-expanded", willExpand);
    };

    if (mobileAncherMenu && mobileAncherMenu.dataset.boundToggle !== '1') {
      mobileAncherMenu.addEventListener("click", toggleHandler);
      if (mobileAncherMenu.dataset) mobileAncherMenu.dataset.boundToggle = '1';
    }

    return () => {
      observer.disconnect();
      linksArr.forEach((el) => {
        if (el.dataset.boundClick === '1') {
          el.removeEventListener("click", clickHandler);
          delete el.dataset.boundClick;
        }
      });
      if (mobileAncherMenu && mobileAncherMenu.dataset.boundToggle === '1') {
        mobileAncherMenu.removeEventListener("click", toggleHandler);
        delete mobileAncherMenu.dataset.boundToggle;
      }
      if (clickTimeoutId) {
        clearTimeout(clickTimeoutId);
        clickTimeoutId = null;
      }
      if (widgetElement && widgetElement.dataset) {
        delete widgetElement.dataset.stickyNavInit;
      }
    };
  }

  return advancedStickyNav;
}

const scrollIntoViewWithOffset = (selector, offset) => {
  if (!selector) return;
  const element = document.querySelector(selector);
  if (!element) return;

  const scroller = document.scrollingElement || document.documentElement || document.body;
  if (!scroller) return;
  
  const effectiveOffset = Math.max(0, (offset || 0));

  const vvTop = (window.visualViewport && window.visualViewport.offsetTop) || 0;

  const currentScroll = scroller.scrollTop;

  const targetTopInViewport = element.getBoundingClientRect().top;

  const targetY = Math.max(0, currentScroll + targetTopInViewport + vvTop - effectiveOffset);

  scroller.scrollTo({ top: targetY, behavior: 'smooth' });
};


export default StickyNavHook;
